import parse from "html-react-parser";

export const searchHighlight = (obj: any, prop: string, name: any) => {
  return obj?.[prop] ? parse(obj?.[prop]?.[0]) : name;
};
